import React, { useEffect, useState, useRef, useImperativeHandle, useMemo, forwardRef, useCallback } from 'react';

import KhongDau from 'khong-dau';
import AntLocalization from '../utils/AntLocalization';
import AntString from '../utils/AntString';
import { SelectBox } from 'devextreme-react';
import AntQueryStore from '../components/AntQueryStore';
import CustomStore from 'devextreme/data/custom_store';

import Tabs, { Item as TabItem } from 'devextreme-react/tabs';

// import { AntGlobal, AntSession } from '../utils/AntContext';

export default forwardRef(function (props, ref) {
    // const appGlobal = AntGlobal();
    // const session = AntSession();

    // const tableName = props.options && props.options.table ? props.options.table : props.table ? props.table : props.API.entityName;

    // const config = useMemo(() => {
    //     let cnf = new AntConfig(appGlobal, tableName);
    //     cnf.configFields(props.options && props.options.fields instanceof Array ? props.options.fields : null);
    //     return cnf;
    // }, []);

    const [data, setData] = useState(null);
    const [mainValue, setMainValue] = useState(props.value);

    const getSearchConditions = useCallback(() => {
        var obj = {
            lkTableName: props.lkTableName ? props.lkTableName : props.options && props.options.table ? props.options.table : props.table,
            lkName: !props.url && props.lookupName ? props.lookupName : undefined
        };

        if (typeof props.searchConditions === 'object' && props.searchConditions !== null)
            Object.keys(props.searchConditions).forEach((k) => {
                if (props.searchConditions[k] !== undefined) obj[k] = props.searchConditions[k];
            });

        if (props.parentFields instanceof Array) {
            var formData = null;
            if (props.formRef && props.formRef.current && props.formRef.current.instance)
                formData = props.formRef.current.instance.option('formData');

            if (formData) {
                props.parentFields.forEach((field) => {
                    if (typeof field === 'object' && field !== null) {
                        var parentField = field.field;
                        var aliasField = field.alias;
                        if (formData && formData[parentField] !== undefined && formData[parentField] !== null)
                            obj[aliasField] = formData[parentField];
                    } else if (formData && formData[field] !== undefined && formData[field] !== null) obj[field] = formData[field];
                });
            }
        }

        Object.keys(obj).map((k) => {
            if (obj[k] === null) obj[k] = undefined;
        });

        Object.keys(obj).forEach((key) => {
            if (obj[key] === undefined) {
                delete obj[key];
            }
        });
        obj.isSearching = props.isSearching !== undefined ? props.isSearching : true;

        return obj;
    }, [props.lkTableName, props.searchConditions, props.parentFields, props.formRef, props.formRef?.current]);

    const getQueryFields = useCallback(() => {
        var ar = ['created_at', 'checksum', 'id', 'code', props.options?.valueExpr, props.options?.displayExpr, props.options?.keyExpr];

        if (props.getQueryFields) {
            var fields = props.getQueryFields();
            if (fields instanceof Array) ar.push(...fields);
        }

        ar = ar
            .filter((v) => Boolean(v))
            .filter((v, index, self) => {
                return self.indexOf(v) === index;
            });

        return ar;
    }, [props.options, props.getQueryFields]);

    const getOrderings = useCallback(() => {
        if (props.ordering instanceof Array) return props.ordering;
        return null;
    }, [props.ordering]);

    const initClientDataSource = useCallback(() => {
        var valueExpr = props.options.valueExpr;
        var displayExpr = props.options.displayExpr;

        let obj = [];

        if (!props.isRemote) {
            obj = props.options.dataSource;
            if (obj instanceof Array && obj.length > 0)
                obj = obj.map((v, i) => {
                    if (typeof v === 'object')
                        return {
                            ...v,
                            [displayExpr]:
                                v[displayExpr] !== undefined
                                    ? AntLocalization.translateText(v[displayExpr])
                                    : AntLocalization.translateText(v[valueExpr])
                        };
                    else
                        return {
                            [valueExpr]: v,
                            [displayExpr]: AntLocalization.translateText(v)
                        };
                });
        }

        return obj;
    }, [props.options, props.isRemote, props.formRef, props.formRef?.current]);

    const onDatasourceGotData = useCallback((data) => {
        setData(data.data);
    }, []);

    const initRemoteDataSource = useCallback(() => {
        var formData = null;
        if (props.formRef && props.formRef.current && props.formRef.current.instance) formData = props.formRef.current.instance.option('formData');

        var valueExpr = props.options.valueExpr;
        var displayExpr = props.options.displayExpr;

        let obj;

        if (props.isRemote && !props.useCustomStore) {
            obj = new AntQueryStore({
                key: props.options.keyExpr ? props.options.keyExpr : 'id',
                API: props.API,
                url: props.url,
                loadFunc: 'postLookup',
                remotePaging: false,
                getSearchConditions: getSearchConditions,
                getQueryFields: getQueryFields,
                getOrderings: getOrderings,
                onGotData: onDatasourceGotData,
                forceReload: true
            });

            var formField = props.formDisplayField ? props.formDisplayField : String(props.dataField).replace('_code', '_name');
            if (formData && formData[formField] !== undefined) {
                obj.addDefaultData([
                    {
                        [valueExpr]: formData[props.dataField],
                        [displayExpr]: formData[formField]
                    }
                ]);
            }
        }

        return obj;
    }, [
        props.options,
        props.useCustomStore,
        props.API,
        props.url,
        props.remotePaging,
        props.formDisplayField,
        props.dataField,
        props.url,
        props.formRef,
        props.formRef?.current,
        getSearchConditions,
        getQueryFields,
        getOrderings,
        onDatasourceGotData
    ]);

    const clientDatasource = useMemo(() => initClientDataSource(), [initClientDataSource]);

    const remoteDataSource = useMemo(() => initRemoteDataSource(), [initRemoteDataSource]);

    const resetRemoteDataSource = useCallback(() => {
        if (remoteDataSource)
            remoteDataSource.reInit({
                key: remoteDataSource.key,
                API: remoteDataSource.API,
                url: remoteDataSource.url,
                loadFunc: 'postLookup',
                remotePaging: false,
                getSearchConditions: getSearchConditions,
                getQueryFields: getQueryFields,
                getOrderings: getOrderings,
                onGotData: onDatasourceGotData,
                forceReload: true
            });
    }, [remoteDataSource, getSearchConditions, getQueryFields, getOrderings, onDatasourceGotData]);

    useEffect(() => {
        if (!props.isRemote) {
            setData(clientDatasource);
        }
    }, [clientDatasource]);

    useEffect(() => {}, [resetRemoteDataSource]);

    var valueExpr = props.options.valueExpr;
    var displayExpr = props.options.displayExpr;

    const tabItemRender = useCallback(
        (data) => {
            let strText = `${data[props.options.displayExpr]}`;
            if (props.onCustomText) strText = props.onCustomText(data, strText);

            let isSelected = mainValue && data && data[props.options.valueExpr] === mainValue;
            return (
                <div className={Boolean(isSelected) ? 'ant-pos-select-bar-item ant-pos-select-bar-item-selected' : 'ant-pos-select-bar-item'}>
                    {strText}
                </div>
            );
        },
        [props.onCustomText, mainValue]
    );

    const onItemClick = useCallback(
        (e) => {
            let item = e.itemData;
            let fVallue = item[props.options.valueExpr];
            let oldVallue = mainValue;

            if (props.onValueChanged) {
                props.onValueChanged({
                    value: fVallue,
                    rowData: item,
                    previousValue: oldVallue
                });
            }

            setMainValue(fVallue);
        },
        [props.onValueChanged, mainValue]
    );

    useEffect(() => {
        setMainValue(props.value);

        if (props.isRemote && !data) resetRemoteDataSource();
    }, [props.value]);

    return (
        <React.Fragment>
            <Tabs
                className={'ant-pos-select-bar'}
                noDataText={''}
                itemRender={tabItemRender}
                selectedItem={mainValue}
                animationEnabled={false}
                swipeEnabled={false}
                // selectedIndex={orders.findIndex((o) => o.id === mainValue?.id)}
                // onSelectionChanged={onSelectionChanged}
                onItemClick={onItemClick}
                items={data ? data : []}
                focusStateEnabled={false}
                hoverStateEnabled={false}
            />
        </React.Fragment>
    );
});
